import { ErrorMessage } from "@hookform/error-message";

function FormErrorMessage({ errors, formControlName }) {
  return (
    <div className="danger_container">
      <ErrorMessage
        errors={errors}
        name={formControlName}
        render={({ message, messages }) => {
          const list =
            messages && typeof messages === "object"
              ? Object.values(messages)
              : message
              ? [message]
              : [];

          return list.length
            ? list.map((msg, i) => (
                <span key={i} className="danger">
                  {msg}
                </span>
              ))
            : null;
        }}
      />
    </div>
  );
}

export default FormErrorMessage;
